var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import manualAssetUpdate from '../../requests/asset/manualAssetUpdate';
/**
 *
 */
var UpdateManualAssetDefinitionCommand = /** @class */ (function (_super) {
    __extends(UpdateManualAssetDefinitionCommand, _super);
    function UpdateManualAssetDefinitionCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param manualAssetModel ManualAssetModel
     * @param organisationId string
     * @param intl
     * @return {*}
     */
    UpdateManualAssetDefinitionCommand.prototype.execute = function (manualAssetModel, organisationId, intl) {
        this.intl = intl;
        this.manualAssetModel = manualAssetModel;
        var promise = manualAssetUpdate(manualAssetModel.toUpdateRequest(), organisationId, manualAssetModel.id);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    UpdateManualAssetDefinitionCommand.prototype.then = function (response) {
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.asset.updated' }, Object(this.manualAssetModel)), 'dark', true);
    };
    return UpdateManualAssetDefinitionCommand;
}(Command));
export default UpdateManualAssetDefinitionCommand;
